import React, { useEffect, useState } from 'react';
import cn from 'classnames';
import { useRouter } from 'next/router';
import styles from './BlogPage.module.css';
import { BlogPage } from '@desquared/wave-components-library';
import { shownProducts } from '@/components/BlogPage/useBlogs';
import { setBlogs } from '@/utils/corporateUtils';
import { useIsRtl } from '@/contexts/DirectionContext.jsx';

export default function BlogPageSection(props) {
  const perPage = props.data.full_size_blog ? 4 : 6;
  const [lastPage, setLastPage] = useState(Math.ceil(props.blogs.length / perPage));
  const [chips, setChips] = useState(
    props.data.blog_tag.categories.map((el, index) => {
      return { text: el, selected: index === 0, _id: index };
    })
  );
  const [current, setCurrent] = useState(1);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const isRtl = useIsRtl();

  const [blogs, setBlog] = useState(
    shownProducts(setBlogs(props.blogs, props.data.blog_tag.categories, props.data.blog_posts), current - 1, perPage)
  );

  const router = useRouter();

  const selectChip = item => {
    let localSelectedIndex = 0;
    let list = chips.map((el, i) => {
      if (item._id === el._id) {
        localSelectedIndex = i;
        setSelectedIndex(i);
      }
      return { text: el.text, selected: item.text === el.text, _id: i };
    });
    setChips(list);
    let bloggs = setBlogs(props.blogs, props.data.blog_tag.categories, props.data.blog_posts);
    if (localSelectedIndex !== 0) {
      bloggs = bloggs.filter(el => el.tag === props.data.blog_tag.categories[localSelectedIndex]);
    }
    setLastPage(Math.ceil(bloggs.length / perPage));
    setCurrent(1);

    setBlog(shownProducts(bloggs, current - 1, perPage));
  };

  // const selectChips = (chips, index) => {
  //   let list = chips.map((el, i) => {
  //     return { text: el.text, selected: index === i };
  //   });
  //   setChips(list);
  //   let bloggs = setBlogs(props.blogs, props.data.blog_tag.categories, props.data.blog_posts);

  //   if (index !== 0) {
  //     bloggs = bloggs.filter(el => el.tag === props.data.blog_tag.categories[index]);
  //   }
  //   setLastPage(Math.ceil(bloggs.length / perPage));
  //   setCurrent(1);

  //   setBlog(shownProducts(bloggs, current - 1, perPage));
  // };
  const setPage = (cp, pl, updateCurrent) => {
    setCurrent(cp);
    updateCurrent(cp);
    setBlog(shownProducts(setBlogs(props.blogs, props.data.blog_tag.categories, props.data.blog_posts), cp, pl));
  };

  useEffect(() => {
    setBlog(
      shownProducts(setBlogs(props.blogs, props.data.blog_tag.categories, props.data.blog_posts), current - 1, perPage)
    );
  }, [current]);

  return (
    <div className={cn(styles.layout)}>
      <BlogPage
        blogs={blogs}
        title={props.data.title}
        chips={chips}
        size={props.data.full_size_blog ? 'big' : 'small'}
        description={props.data.redirection_block.description}
        buttonText={props.data.redirection_block.button_text}
        onClick={() => router.push(props.data.redirection_block.redirection_link)}
        categoriesTitle={props.data.blog_tag.category_title}
        setPage={cp => setPage(cp, lastPage, setCurrent)}
        current={current}
        pageLimit={perPage}
        totalPage={lastPage}
        // onPress={selectChips}
        onChange={selectChip}
        isRtl={isRtl}
      />
    </div>
  );
}
